<template>
  <div>
    <div>
      <button
        class="my-2 btn btn-info"
        @click="executeAction('generateAllCompanyStats', null)"
      >
        <i class="fa fa-sticky-note" /> Generate Report
      </button>
      <button
        class="my-2 btn btn-primary"
        @click="executeAction('viewAllCompanyStats', null)"
      >
        <i class="fa fa-fw fa-copy" /> View Reports
      </button>
    </div>
  </div>
</template>
<script>
import { 
  GENERATE_ALL_COMPANY_STATS,
  VIEW_ALL_COMPANY_STATS
} from "@/vuex/types";
import { mapActions } from "vuex";
export default {
  name: "GenerateStatsDisplay",
  data() {
    return {
      updatedCompany: {}
    };
  },
  methods: {
    async generateStats() {
      console.log("clicked");
    },
    async executeAction(action, payload) {
      let result = await this[action](payload);
      if (result && result.updated) {
        this.updatedCompany = result.updated;
      }
    },
    ...mapActions([GENERATE_ALL_COMPANY_STATS, VIEW_ALL_COMPANY_STATS])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/GenerateStatsDisplay.vue